let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8yA7N")).then(() => parcelRequire('7pUUW'));